






import Vue from 'vue'

import { TreeListModel, ChildModel } from '../types'
import style from './style.module.scss'

export default Vue.extend({
name: 'select-body-search-list',
  props: {
    searchList: Array as () => TreeListModel<ChildModel>[],
  },
  data() {
    return {
      s: style
    }
  }
})
